/* src/app/features/details/components/details-actions/details-actions.scss */
:host ::ng-deep .details-btn.p-button {
  border-radius: 9999px;
}
:host ::ng-deep .details-btn-primary.p-button {
  background: var(--highlight_primary_85);
  border-color: var(--highlight_primary_85);
  color: var(--hover_hl);
}
:host ::ng-deep .details-btn-primary.p-button:not(:disabled):hover {
  background: var(--highlight_primary);
  border-color: var(--highlight_primary);
}
:host ::ng-deep .details-btn-secondary.p-button {
  background: var(--highlight_secondary_85);
  border-color: var(--highlight_secondary_85);
  color: var(--text_primary);
}
:host ::ng-deep .details-btn-secondary.p-button:not(:disabled):hover {
  background: var(--highlight_secondary);
  border-color: var(--highlight_secondary);
}
/*# sourceMappingURL=details-actions.css.map */
